import { Badge } from "@/components/ui/badge";
import { formatarNome } from "@/utils/formatarNome";
import { TooltipEasy } from "@/components/tooltipEasy";
import { Clock9 } from "lucide-react";
import obterBgBadge from "@/utils/obterBgBadge";
import moment from "moment";
import calcularTempoRestante from "@/utils/calcularTempoRestante";
import { TempoRestante } from "./TempoRestante";
import { PresetActions } from "./PresetActions";


export function ItemAtendente({ id, tempo_ate_agora = "", nome_aluno = "", servico = "", unidade, unidadeId, setor, setorId, servicoId, prazo, createdAt }) {

  const bgBadge = obterBgBadge(prazo, createdAt)
  const prazoMinutos = calcularTempoRestante(prazo, createdAt)

  return (
    <div className="bg-white rounded-md p-2 relative">
      <div className="flex items-center justify-end gap-1 mb-[2px]">
        <TempoRestante tempo={prazoMinutos} />
        <TooltipEasy content={(<span>Horário de chegada<br />{moment(createdAt).format("DD/MM/YY HH:mm")}</span>)}><Badge className={`${bgBadge} text-white`}><Clock9 />{tempo_ate_agora}</Badge></TooltipEasy>
      </div >
      <div className="flex gap-2">
        <div className="w-[4px] bg-[#b9b9b9] rounded-md flex-shrink-0" />
        <div className="grid grid-cols-1 px-2">
          <p className="text-sm/6 font-medium text-gray-900 w-full truncate">{formatarNome(nome_aluno)}</p>
          <p className="text-sm/6 text-gray-700 w-full truncate">{servico}</p>
          {setor && <div className="mt-1 text-sm/6 text-gray-700"><Badge variant="secondary">{setor}</Badge></div>}
        </div>
      </div>
      <div className="flex items-center gap-1 absolute bottom-2 right-2">
        <PresetActions id={id} unidadeId={unidadeId} setorId={setorId} servicoId={servicoId} />
      </div>
    </div >
  )
}